/**
 * Format candidates_calls.call_duration for display.
 * Values are decimal minutes, normalized to hundredths (e.g. 1.24 → 1m 14s).
 */
export const formatCallDuration = (value, emptyLabel = '—') => {
  if (value == null || value === '') return emptyLabel;

  const parsed = typeof value === 'number' ? value : Number(String(value).trim());
  if (!Number.isFinite(parsed) || parsed < 0) {
    const raw = String(value).trim();
    return raw || emptyLabel;
  }

  // Keep DB precision to hundredths of a minute before converting to seconds.
  const minutesDecimal = Math.round(parsed * 100) / 100;
  const totalSeconds = Math.round(minutesDecimal * 60);
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;

  if (mins === 0) return `${secs}s`;
  if (secs === 0) return `${mins}m`;
  return `${mins}m ${secs}s`;
};
